import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useWorkspaceStore from "stores/useWorkspaceStore";
import {
  getMeetingDayString,
  localDateFromDayString,
} from "utils/meetingDay";

const getMeetingDay = (meeting) =>
  getMeetingDayString(
    meeting?.meetingDateIso ||
      meeting?.meetingDate ||
      meeting?.date ||
      meeting?.startDateTime ||
      meeting?.startIso
  );

const useWorkspaceMeetingNavigator = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSelectedDate, setSelectedEventId, setScrollToEventId } =
    useWorkspaceStore();

  return useCallback(
    (meeting) => {
      const meetingId = meeting?.meetingId || meeting?.eventId || meeting?.id;
      if (!meetingId) return;

      // The day as written in the meeting's own offset. Converting to an
      // instant here would re-date the meeting into the viewer's timezone.
      const meetingDay = getMeetingDay(meeting);
      const meetingDate = localDateFromDayString(meetingDay);

      if (meetingDate) {
        setSelectedDate(meetingDate);
      }

      setSelectedEventId(meetingId);
      setScrollToEventId(meetingId);

      if (location.pathname !== "/workspace") {
        // The selection has to travel in the URL, not only in the store:
        // /workspace reloads itself when the document is not cross-origin
        // isolated, and that reload wipes every in-memory store.
        const params = new URLSearchParams({ meetingId });
        if (meetingDay) {
          params.set("meetingDate", meetingDay);
        }
        navigate(`/workspace?${params.toString()}`);
      }
    },
    [
      location.pathname,
      navigate,
      setScrollToEventId,
      setSelectedDate,
      setSelectedEventId,
    ],
  );
};

export default useWorkspaceMeetingNavigator;
